import { useState } from "react";
import { useArtistContext } from "Components";
import IntegrationCard from "../IntegrationCard";
import styled, { CSSProperties } from "styled-components";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { doc, getFirestore } from "firebase/firestore";
import { Button } from "melodies-source/Button";
import { SonyConnectModal, SonyDisconnectModal } from "./SonyModals";
import sonyHeader from "./sony-header.png";

type SonyDocument = {
  enabled?: boolean;
};

const SonyIntegration = ({ sx }: { sx?: CSSProperties }) => {
  const [connectModalOpen, setConnectModalOpen] = useState(false);
  const [disconnectModalOpen, setDisconnectModalOpen] = useState(false);

  const { id: artistGroupId } = useArtistContext();

  const [sonyDoc] = useDocumentData<SonyDocument>(
    doc(
      getFirestore(),
      `artist_groups/${artistGroupId}/artist_group_private/sony`,
    ) as any,
  );

  const isConnected = !!sonyDoc?.enabled;

  return (
    <>
      {connectModalOpen && (
        <SonyConnectModal
          artistGroupId={artistGroupId}
          isOpen
          onClose={() => setConnectModalOpen(false)}
        />
      )}
      {disconnectModalOpen && (
        <SonyDisconnectModal
          artistGroupId={artistGroupId}
          isOpen
          onClose={() => setDisconnectModalOpen(false)}
        />
      )}
      <SonyIntegrationCard
        isConnected={isConnected}
        onConnect={() => setConnectModalOpen(true)}
        onDisconnect={() => setDisconnectModalOpen(true)}
        sx={sx}
      />
    </>
  );
};

export default SonyIntegration;

const SonyIntegrationCard = ({
  isConnected,
  onConnect,
  onDisconnect,
  sx,
}: {
  isConnected: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
  sx?: CSSProperties;
}) => {
  if (isConnected) {
    return (
      <IntegrationCard
        header={<img src={sonyHeader} alt="sony music logo" />}
        body={<BodyText>You're connected to Sony Music!</BodyText>}
        footer={
          <FooterText
            style={{ textAlign: "center" }}
            onClick={() => onDisconnect()}
          >
            Disconnect Sony Music
          </FooterText>
        }
        sx={sx}
      />
    );
  }

  return (
    <IntegrationCard
      header={<img src={sonyHeader} alt="sony music logo" />}
      footer={
        <Button onClick={() => onConnect()}>Connect to Sony Music</Button>
      }
      body="Connect your artist to Sony Music to enable Sony opt-ins on your SET.live shows. Click the button below to get started."
      sx={sx}
    />
  );
};

const BodyText = styled.div`
  font-size: 10px;
  line-height: 170%;
  font-weight: 400;
  text-align: center;
  color: #666;
`;

const FooterText = styled.div`
  color: #180171;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0px;
  margin: 0 auto;
  padding-bottom: 5px;
  cursor: pointer;
  bottom: 0;
`;
